import React from "react";
import { Card, CardContent, Grid, makeStyles } from "@material-ui/core";
import { emptyArray } from "constants/defaultValues";
import { useQueryWithErrorHandling } from "hooks/errorHandling";
import { useTranslation } from "react-i18next";
import { LANGUAGES_QUERY } from "utils/languages";
import TranslationComponent from "./TranslationComponent";
import styles from "features/settings/styles";
import SectionTitle from "features/common/components/SectionTitle";

const useStyles = makeStyles(styles);

const TranslationsContainer = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { data } = useQueryWithErrorHandling(LANGUAGES_QUERY);
  const languages = data?.languages || emptyArray;

  return (
    <Card>
      <CardContent>
        <SectionTitle title={t("Settings.Translations.Title")} />
        <Grid container direction="row" spacing={2}>
          {languages.map((language, index) => (
            <Grid
              item
              xs={12}
              key={index}
              className={index === 0 ? classes.firstLanguageBorder : classes.restOfLanguagesBorder}
            >
              <TranslationComponent language={language} />
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default TranslationsContainer;
